import React from 'react'

const BillingHistory = () => {
  return (
    <div>BillingHistory</div>
  )
}

export default BillingHistory